import value from '../runtime/runtime.js';
export default value;



// WEBPACK FOOTER //
// ./~/jose/dist/browser/util/runtime.js